import { Grid, useMediaQuery } from '@mui/material';
import { useState } from 'react';
import FormAutocomplete from '~/components/FormComponents/FormAutocomplete';
import { FormInput } from '~/components/FormComponents/FormInput';
import { TariffList } from './TariffList';
import { useTariffsQuery } from '~/queries/useTariffQuery';
import { useFormContext, useWatch } from 'react-hook-form';
import { useServicePointsQuery } from '~/queries/useServicePointsQuery';
import CurrencyList from './CurrencyList';
import { theme } from '~/theme';
import { QuestionnaireModal } from './QuestionnaireModal';
import TitlePencilField from '~/components/TitlePencilField/TitlePencilFIeld';
import { errorMessages } from '~/constants/errorMessages';
import { useNavigate } from 'react-router';
import { useSelector } from 'react-redux';
import { QUESTION_FIELDS } from '../constants.tsx';
import { selectCompletedForms } from '~/store/identification-form/selectors.ts';
import { setIdentificationError } from '~/store/identification-form/slices.ts';
import { useAppDispatch } from '~/store/appDispatch.ts';

export const CreationClientInfo = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { setValue, control } = useFormContext();
  const { isGettingStartedCompleted } = useSelector(selectCompletedForms) || {};
  const [regionId, contragentType] = useWatch({
    control,
    name: ['region.value', 'contragentType.value'],
  });
  const {
    formState: { errors },
  } = useFormContext();

  const hasError = Object.keys(errors).some((item) => QUESTION_FIELDS.includes(item));

  const { regions, servicePoints } = useServicePointsQuery(regionId);
  const { tarrifs, autocompleteTarrifs } = useTariffsQuery(contragentType);
  const [isModalOpened, setIsModalOpened] = useState(false);

  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const handleClose = (shouldExit?: boolean) => {
    if (shouldExit) {
      dispatch(
        setIdentificationError({
          errorMessage: errorMessages.VISIT_BRANCH_REQUIRED,
          discard: () => navigate('/services'),
        })
      );
    }
    setIsModalOpened(false);
  };

  const handleOpen = () => {
    setIsModalOpened(true);
  };

  return (
    <>
      <Grid container spacing={{ xs: 2, sm: 3 }} sx={{ width: '100%' }}>
        <Grid size={{ md: 6, sm: 12, xs: 12 }}>
          <FormInput name="contragentType.label" disabled label="Тип клієнта" fullWidth />
        </Grid>
        <Grid size={{ md: 6, sm: 12, xs: 12 }}>
          <FormAutocomplete
            options={autocompleteTarrifs}
            label="Тарифний пакет"
            name="tariffPackage"
            inputProps={{
              placeholder: 'Оберіть тарифний пакет',
            }}
          />
        </Grid>
        {isMobile && (
          <Grid size={{ md: 6, sm: 12, xs: 12 }}>
            <TariffList tarrifs={tarrifs} />
          </Grid>
        )}
        <Grid size={{ md: 6, sm: 12, xs: 12 }}>
          <FormAutocomplete
            options={regions}
            inputProps={{
              placeholder: 'Оберіть регіон обслуговування',
            }}
            onChange={() => setValue('tobo', null)}
            label="Точка обслуговування"
            name="region"
          />
          <FormAutocomplete
            options={servicePoints}
            inputProps={{
              placeholder: 'Оберіть точку обслуговування',
            }}
            name="tobo"
            disabled={!regionId}
          />
        </Grid>
        {!isMobile && (
          <Grid size={{ md: 6, sm: 12, xs: 12 }}>
            <TariffList tarrifs={tarrifs} />
          </Grid>
        )}
        <CurrencyList />
        {!isGettingStartedCompleted && (
          <Grid size={12}>
            <TitlePencilField
              title="Надайте уточнюючу інформацію"
              dataName="explanation"
              onClick={handleOpen}
              errorMessage={hasError ? errorMessages.FILL_CLARIFYING_INFORMATION : ''}
            />
          </Grid>
        )}
      </Grid>
      <QuestionnaireModal isOpened={isModalOpened} onContinue={handleClose} />
    </>
  );
};
